import { render, staticRenderFns } from "./NewList1.vue?vue&type=template&id=17d4da66&scoped=true&"
import script from "./NewList1.vue?vue&type=script&lang=js&"
export * from "./NewList1.vue?vue&type=script&lang=js&"
import style0 from "./NewList1.vue?vue&type=style&index=0&id=17d4da66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d4da66",
  null
  
)

export default component.exports